import * as React from "react";

function SvgBlackBird(props) {
  return <svg width={34} height={33} fill="none" {...props}><path fill="#000" fillRule="evenodd" d="M20 27.5c7.9-2.3 11-9.5 10.5-17.9l2.7-2-3.1-1.1C29 2 25 .2 21.6.9a7.6 7.6 0 0 0-6 8c3.3 1.5 4.8 5 3.2 8.4v-.8a6.7 6.7 0 0 0-6.4-7C9 9.4 3.4 13.5.8 16c2.3 2.5 7.5 6.8 11 7-1.8 1.2-4.2 1.5-7.2 1.2 2 2 4.6 3.3 7.2 3.8 1 .2 2 .3 3.1.3l-1.7 3.3 1.3.7 2.1-4.1 1.5-.2-1.8 3.6 1.2.7 2.5-4.7zm4.3-23.3c.7 0 1.2.5 1.2 1 0 .7-.5 1.2-1.2 1.2-.6 0-1.2-.5-1.2-1.1 0-.6.6-1.1 1.2-1.1z" clipRule="evenodd" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/black-bird_cadd5d.svg";
export { SvgBlackBird as ReactComponent };